var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{on:{"click":_vm.captureImage}},[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }